<template>
  <div class="navbar">
    <div class="navbar__inner">
      <div class="navbar__left">
        <div v-if = "$route.path !== '/my-workbench/document-template/create-document'" class="navbar__logo">
          <svg width="36" height="32" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.8958 3.75336C21.8958 5.82628 20.2097 7.50672 18.1299 7.50672C16.05 7.50672 14.3639 5.82628 14.3639 3.75336C14.3639 1.68044 16.05 0 18.1299 0C20.2097 0 21.8958 1.68044 21.8958 3.75336Z" fill="#8BBDC7"/>
            <path d="M30.2069 17.9902C30.2069 20.0632 28.5208 21.7436 26.4409 21.7436C24.3611 21.7436 22.675 20.0632 22.675 17.9902C22.675 15.9173 24.3611 14.2369 26.4409 14.2369C28.5208 14.2369 30.2069 15.9173 30.2069 17.9902Z" fill="#8BBDC7"/>
            <path d="M13.325 17.9902C13.325 20.0632 11.6389 21.7436 9.55906 21.7436C7.47918 21.7436 5.7931 20.0632 5.7931 17.9902C5.7931 15.9173 7.47918 14.2369 9.55906 14.2369C11.6389 14.2369 13.325 15.9173 13.325 17.9902Z" fill="#8BBDC7"/>
            <path d="M24.2387 6.85603C23.3735 9.44726 20.9073 11.317 18 11.317C15.0924 11.317 12.6259 9.44674 11.761 6.85494C11.4901 6.24669 11.2491 5.53605 11.0264 4.71625L11.0208 4.71854L11.0128 4.68297C10.9975 4.61615 10.9808 4.54933 10.9626 4.48251C10.2134 1.72541 7.33936 0.0889792 4.54331 0.827798C1.74714 1.56662 0.0878923 4.4007 0.837071 7.15781C1.58625 9.91517 4.4603 11.5513 7.25634 10.8125C7.33602 10.7914 7.4148 10.7686 7.49268 10.7442L7.49345 10.75C8.94715 10.3659 10.1358 10.196 11.1227 10.2765C11.1378 10.2764 11.1529 10.2764 11.168 10.2764C14.7961 10.2764 17.7373 13.1884 17.7373 16.7804C17.7373 18.9066 16.7068 20.7945 15.1134 21.9813C14.9877 22.1112 14.8568 22.2429 14.7205 22.3765L14.7253 22.3801C14.6923 22.4095 14.6597 22.4395 14.6275 22.4698L14.5467 22.5475C12.4943 24.561 12.4943 27.8257 14.5467 29.8394C16.5991 31.8529 19.9265 31.8529 21.9789 29.8394C24.0313 27.8257 24.0313 24.561 21.9789 22.5475C21.9203 22.4901 21.861 22.4342 21.8003 22.3801L21.8051 22.3765C21.3552 21.9351 20.9624 21.5148 20.6268 21.1102C19.4895 19.9607 18.7883 18.3866 18.7883 16.6504C18.7883 13.3336 21.347 10.6086 24.6167 10.3046C25.6528 10.1677 26.9221 10.3314 28.5066 10.75L28.5074 10.7444C28.4146 10.7152 28.3231 10.6837 28.2331 10.6499C28.3986 10.7119 28.569 10.7663 28.7437 10.8125C31.5398 11.5513 34.4138 9.91517 35.163 7.15781C35.9122 4.4007 34.2529 1.56662 31.4568 0.827798C28.6607 0.0889792 25.7867 1.72541 25.0375 4.48251C25.0161 4.56127 24.9967 4.63978 24.9792 4.71854L24.9737 4.71625C24.7509 5.53638 24.5098 6.24742 24.2387 6.85603Z" fill="#004879"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3282 4.65159C9.67367 2.2429 7.16072 0.809451 4.71267 1.45632C2.26545 2.10294 0.817175 4.58128 1.4714 6.98895C2.12588 9.39777 4.63866 10.831 7.08666 10.1843M11.5968 4.31311C10.7527 1.20792 7.51773 -0.631226 4.37388 0.199498C1.22876 1.03052 -0.641468 4.22035 0.202662 7.32689C1.04651 10.4327 4.2817 12.2718 7.4257 11.441C7.48807 11.4245 7.54998 11.4071 7.6109 11.3889L7.61172 11.3919L7.66124 11.379L7.66283 11.3785C9.08716 11.0021 10.1914 10.8533 11.0687 10.9249L11.0978 10.9272L11.1271 10.927C11.1407 10.927 11.1543 10.9269 11.168 10.9269C14.4333 10.9269 17.0803 13.5477 17.0803 16.7806C17.0803 18.6937 16.154 20.3924 14.7185 21.4616L14.6759 21.4933L14.6391 21.5314C14.5176 21.657 14.3906 21.7846 14.2581 21.9146L14.256 21.9167L14.2198 21.9525L14.222 21.9547C14.2062 21.9691 14.1908 21.9836 14.1755 21.9979L14.1726 22.0006L14.0866 22.0833L14.0843 22.0856C11.7725 24.3536 11.7725 28.0333 14.0842 30.3015C16.3927 32.5661 20.1328 32.5662 22.4413 30.3015C24.753 28.0334 24.7531 24.3536 22.4413 22.0856C22.3967 22.042 22.3506 21.998 22.3036 21.9546L22.3057 21.9525L22.2696 21.9167L22.2674 21.9146C21.8294 21.4848 21.4525 21.081 21.1344 20.6975L21.1162 20.6756L21.0961 20.6552C20.0742 19.6223 19.4452 18.2098 19.4452 16.6505C19.4452 13.6726 21.7428 11.2252 24.6781 10.9523L24.6909 10.9511L24.7036 10.9494C25.6123 10.8293 26.7826 10.9678 28.3372 11.3786L28.3388 11.379L28.3883 11.3919L28.3891 11.3889C28.4503 11.4072 28.5119 11.4245 28.5741 11.441C31.7181 12.2718 34.9535 10.4327 35.7973 7.32689C36.6415 4.22035 34.7712 1.03052 31.6261 0.199498C28.4821 -0.631275 25.2469 1.20814 24.4031 4.31365C24.3865 4.3747 24.3709 4.4357 24.3564 4.49683L24.3535 4.49603L24.34 4.54481L24.3393 4.54742C24.1222 5.34668 23.8912 6.0243 23.6376 6.59364L23.6248 6.62227L23.6149 6.65199C22.836 8.98481 20.6155 10.6667 18 10.6667C15.3841 10.6667 13.1634 8.98434 12.3848 6.65101L12.3748 6.62126L12.3621 6.59259C12.1086 6.02357 11.8778 5.34633 11.6607 4.5474L11.6465 4.49603L11.6435 4.49684C11.6291 4.43594 11.6135 4.37433 11.5968 4.31311ZM10.3282 4.65159C10.3439 4.70926 10.3585 4.7677 10.3718 4.82585L10.3282 4.65159ZM10.3718 4.82585L10.5519 5.61809L10.5987 5.59867C10.767 6.14181 10.9483 6.6386 11.1473 7.08906C11.498 8.12447 12.0814 9.05436 12.8361 9.81767C12.3006 9.69239 11.7421 9.6261 11.168 9.6261C11.1611 9.6261 11.1542 9.62611 11.1473 9.62613C10.2411 9.5565 9.21474 9.67676 8.04952 9.94259L8.04258 9.8899L7.29453 10.1242C7.22561 10.1458 7.15616 10.1659 7.08666 10.1843M16.3321 11.7761C17.2887 12.7436 17.9702 13.9788 18.2513 15.3578C18.5261 13.8949 19.2588 12.5915 20.2966 11.5987C19.5751 11.8379 18.8029 11.9676 18 11.9676C17.4259 11.9676 16.8675 11.9013 16.3321 11.7761ZM22.9988 9.97937C23.4917 9.81814 24.0085 9.70894 24.5426 9.65833C25.6502 9.51455 26.943 9.68017 28.4566 10.0649L28.4655 10.0417L28.4673 10.0424C28.6115 10.0963 28.7603 10.1438 28.9131 10.1842C31.3612 10.8311 33.8741 9.39787 34.5286 6.98895C35.1828 4.58128 33.7346 2.10294 31.2873 1.45632C28.8393 0.809453 26.3263 2.2429 25.6718 4.65159C25.6531 4.72058 25.6361 4.78934 25.6209 4.85801L25.4521 5.61973L25.4013 5.59868C25.2329 6.14221 25.0515 6.63939 24.8523 7.09022C24.4764 8.19945 23.8334 9.18752 22.9988 9.97937ZM18.2768 18.0716C17.9628 19.7765 17.0385 21.2705 15.7376 22.3231L15.755 22.3361L15.1654 22.863C15.138 22.8875 15.1103 22.9129 15.0823 22.9392L15.0069 23.0118C13.2161 24.7709 13.2167 27.6189 15.009 29.3775C16.8054 31.1398 19.7202 31.1398 21.5165 29.3775C23.3094 27.6184 23.3095 24.769 21.5169 23.01M18.2768 18.0716C18.554 19.4068 19.2139 20.604 20.1372 21.5449C20.3443 21.7934 20.5703 22.0458 20.8147 22.303L20.7698 22.3366L21.3607 22.8635C21.4123 22.9095 21.4641 22.9583 21.5169 23.01" fill="#004879"/>
          </svg>
        </div>

        <div
          v-if="$route.path.includes('/my-workbench/document-template/create-document')"
          class="navbar__portal"
          role="link"
          tabindex="0"
          @click="handleBackToDocumentTemplate"
          @keydown.enter.prevent="handleBackToDocumentTemplate"
          @keydown.space.prevent="handleBackToDocumentTemplate"
        >
          <span class="navbar__portal-text">Back</span>
          <span class="navbar__portal-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
              <path d="M8.82875 14.2908L10.0625 15.5833L14.4375 11L10.0625 6.41667L8.82875 7.70917L11.0863 10.0833H2.625V11.9167H11.0863L8.82875 14.2908ZM16.625 2.75H4.375C3.40375 2.75 2.625 3.575 2.625 4.58333V8.25H4.375V4.58333H16.625V17.4167H4.375V13.75H2.625V17.4167C2.625 18.425 3.40375 19.25 4.375 19.25H16.625C17.5875 19.25 18.375 18.425 18.375 17.4167V4.58333C18.375 3.575 17.5875 2.75 16.625 2.75Z" fill="currentColor"/>
            </svg>
          </span>
        </div>
        <SwitchPlatformMenu v-else />
      </div>

      <div class="navbar__tabs" aria-label="Primary">
        <!-- VP-18687: only the Clinical Calendar is in use; other VI tabs are hidden. -->
        <template v-if="!clinicalCalendarOnly">
        <RouterLink
          to="/my-patients"
          class="navbar__tab"
          :class="{ 'navbar__tab--active': isActive('/my-patients') }"
        >
          <span class="navbar__tab-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 15 14" fill="currentColor">
              <path d="M4.57273 3.18586C4.57273 1.42636 5.94029 0 7.62727 0C9.31425 0 10.6818 1.42636 10.6818 3.18586C10.6818 4.94537 9.31425 6.37172 7.62727 6.37172C5.94029 6.37172 4.57273 4.94537 4.57273 3.18586Z" fill="currentColor"/>
              <path d="M0.5 11.2567C0.5 9.49721 1.86757 8.07085 3.55455 8.07085H3.8322C3.98248 8.07085 4.13181 8.09564 4.27466 8.14429L4.97966 8.38439C5.76285 8.65112 6.58618 8.74246 7.39686 8.65842C7.52731 8.6449 7.62756 8.78625 7.57817 8.91291C7.34723 9.50524 7.22 10.1531 7.22 10.8319C7.22 11.8958 7.53246 12.8835 8.06689 13.7007C8.1415 13.8148 8.06979 13.975 7.93746 13.9798C5.80349 14.0565 3.6641 13.9149 1.55017 13.5549C0.944647 13.4518 0.5 12.9062 0.5 12.2662V11.2567Z" fill="currentColor"/>
              <path d="M14.5 10.0554C14.5 12.1461 11.5278 13.8384 11.4013 13.9083C11.3679 13.927 11.3306 13.9368 11.2927 13.9368C11.2548 13.9368 11.2176 13.927 11.1842 13.9083C11.0883 13.8545 9.36435 12.8722 8.53018 11.4923C8.51942 11.4742 8.51348 11.4535 8.51298 11.4322C8.51248 11.4109 8.51743 11.3899 8.52733 11.3713C8.53722 11.3527 8.5517 11.3372 8.56927 11.3264C8.58684 11.3156 8.60686 11.3099 8.62725 11.3098H9.68909C9.72682 11.3098 9.76397 11.3001 9.79724 11.2816C9.83051 11.263 9.85887 11.2362 9.87981 11.2035L10.1473 10.7853L10.8729 11.9203C10.9007 11.9638 10.9414 11.9966 10.9888 12.0136C11.0362 12.0307 11.0876 12.031 11.1352 12.0147C11.1857 11.9968 11.2289 11.9617 11.2578 11.9149L11.6444 11.3098H12.2091C12.2405 11.3099 12.2716 11.3032 12.3004 11.2902C12.3292 11.2772 12.3552 11.2582 12.3767 11.2343C12.3982 11.2104 12.4147 11.1822 12.4253 11.1513C12.4359 11.1205 12.4403 11.0877 12.4382 11.055C12.4331 10.9936 12.4059 10.9365 12.362 10.8951C12.3182 10.8537 12.261 10.8312 12.2019 10.8319H11.5218C11.4841 10.8319 11.4469 10.8416 11.4137 10.8601C11.3804 10.8787 11.352 10.9055 11.3311 10.9383L11.0636 11.3564L10.338 10.2214C10.3102 10.1779 10.2694 10.1451 10.222 10.128C10.1745 10.111 10.123 10.1106 10.0754 10.1271C10.025 10.145 9.98194 10.1801 9.95312 10.2268L9.56653 10.8319H8.30109C8.27661 10.832 8.25275 10.8239 8.23301 10.8088C8.21327 10.7937 8.19869 10.7724 8.19141 10.748C8.12231 10.5241 8.08658 10.2905 8.08545 10.0554C8.08599 9.56442 8.27321 9.09374 8.60606 8.74658C8.93891 8.39942 9.39019 8.20415 9.86091 8.2036C10.4522 8.2036 10.97 8.46882 11.2927 8.91713C11.6155 8.46882 12.1332 8.2036 12.7245 8.2036C13.1953 8.20415 13.6465 8.39942 13.9794 8.74658C14.3122 9.09374 14.4995 9.56442 14.5 10.0554Z" fill="currentColor"/>
            </svg>
          </span>
          <span class="navbar__tab-text">My Patients</span>
        </RouterLink>

        <span class="navbar__separator" aria-hidden="true"></span>
        </template>

        <RouterLink
          to="/my-calendar"
          class="navbar__tab"
          data-testid="navbar.primary-tabs.my-calendar-link"
          :class="{ 'navbar__tab--active': isActive('/my-calendar') }"
        >
          <span class="navbar__tab-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 17 20" fill="currentColor">
              <path d="M14.625 2.66665H13.75V0.833313H12V2.66665H5V0.833313H3.25V2.66665H2.375C1.40375 2.66665 0.63375 3.49165 0.63375 4.49998L0.625 17.3333C0.625 18.3416 1.40375 19.1666 2.375 19.1666H14.625C15.5875 19.1666 16.375 18.3416 16.375 17.3333V4.49998C16.375 3.49165 15.5875 2.66665 14.625 2.66665ZM14.625 17.3333H2.375V8.16665H14.625V17.3333ZM14.625 6.33331H2.375V4.49998H14.625V6.33331ZM5.875 11.8333H4.125V9.99998H5.875V11.8333ZM9.375 11.8333H7.625V9.99998H9.375V11.8333ZM12.875 11.8333H11.125V9.99998H12.875V11.8333ZM5.875 15.5H4.125V13.6666H5.875V15.5ZM9.375 15.5H7.625V13.6666H9.375V15.5ZM12.875 15.5H11.125V13.6666H12.875V15.5Z" fill="currentColor"/>
            </svg>
          </span>
          <span class="navbar__tab-text">My Calendar</span>
        </RouterLink>

        <template v-if="!clinicalCalendarOnly">
        <span class="navbar__separator" aria-hidden="true"></span>

        <RouterLink
          to="/my-workbench"
          class="navbar__tab"
          :class="{ 'navbar__tab--active': isActive('/my-workbench') }"
        >
          <span class="navbar__tab-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 19 20" fill="currentColor">
              <path d="M17.9778 16.113L13.3404 11.2547H12.4741L10.2516 13.583V14.4905L14.8891 19.3488C15.2304 19.7063 15.7816 19.7063 16.1228 19.3488L17.9778 17.4055C18.3191 17.0572 18.3191 16.4705 17.9778 16.113ZM15.5016 17.4147L11.7916 13.528L12.4129 12.8772L16.1228 16.7638L15.5016 17.4147Z" fill="currentColor"/>
              <path d="M14.1891 8.79801L15.4229 7.50551L17.2779 9.44884C18.3016 8.37634 18.3016 6.63467 17.2779 5.56217L14.1804 2.31717L12.9466 3.60967V1.02467L12.3341 0.37384L9.2366 3.61884L9.85785 4.26967H12.3341L11.1004 5.56217L12.0279 6.53384L9.4991 9.18301L5.88535 5.39717V4.09551L3.24285 1.32717L0.766602 3.92134L3.41785 6.69884H4.6516L8.26535 10.4847L7.5216 11.2638H5.6666L1.0291 16.1222C0.687852 16.4797 0.687852 17.0572 1.0291 17.4147L2.8841 19.358C3.22535 19.7155 3.7766 19.7155 4.11785 19.358L8.75535 14.4997V12.5563L13.2616 7.83551L14.1891 8.79801ZM7.2066 13.5188L3.4966 17.4055L2.87535 16.7547L6.58535 12.868L7.2066 13.5188Z" fill="currentColor"/>
            </svg>
          </span>
          <span class="navbar__tab-text">My Workbench</span>
        </RouterLink>

        <span class="navbar__separator" aria-hidden="true"></span>

        <RouterLink
          to="/my-practice/clinic-dashboard"
          class="navbar__tab"
          :class="{ 'navbar__tab--active': isActive('/my-practice') }"
        >
          <span class="navbar__tab-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 20" fill="currentColor">
              <path d="M10.6912 1.06891C10.5788 0.977032 10.4229 0.977032 10.3104 1.06891L1.12614 8.49687C1.01768 8.58534 0.973346 8.73761 1.0161 8.87627C1.05885 9.01493 1.17998 9.1085 1.31615 9.1085H3.22253V18.6597C3.22253 18.8477 3.36424 19 3.5392 19H17.4603C17.6353 19 17.777 18.8477 17.777 18.6597V9.1085H19.6834C19.8196 9.1085 19.9407 9.01493 19.9835 8.87627C20.027 8.73761 19.9827 8.5845 19.8734 8.49687L10.6912 1.06891ZM17.4609 8.42892C17.2859 8.42892 17.1442 8.58119 17.1442 8.76919V18.3204H3.85662V8.76919C3.85662 8.58119 3.71491 8.42892 3.53995 8.42892H2.26374L10.5005 1.76643L18.7373 8.42892H17.4609Z" fill="currentColor"/>
              <path d="M8.95426 8.42074V10.1107H7.32573C7.02684 10.1107 6.78261 10.3633 6.78261 10.6743V12.7551C6.78261 13.0653 7.02601 13.3179 7.32573 13.3179H8.95426V15.0078C8.95426 15.318 9.19767 15.5714 9.49738 15.5714H11.5026C11.8023 15.5714 12.0457 15.3188 12.0457 15.0078V13.3179H13.6743C13.9732 13.3179 14.2174 13.0653 14.2174 12.7551V10.6743C14.2174 10.3633 13.974 10.1107 13.6743 10.1107H12.0457V8.42074C12.0457 8.11058 11.8023 7.85714 11.5026 7.85714H9.49738C9.19767 7.85714 8.95426 8.10972 8.95426 8.42074ZM9.6166 8.54532H11.3826V10.2353C11.3826 10.5463 11.626 10.7989 11.9257 10.7989H13.5542V12.6314H11.9257C11.626 12.6314 11.3826 12.884 11.3826 13.195V14.885H9.6166V13.195C9.6166 12.884 9.3732 12.6314 9.07349 12.6314H7.44495V10.7989H9.07349C9.3732 10.7989 9.6166 10.5463 9.6166 10.2353V8.54532Z" fill="currentColor"/>
            </svg>
          </span>
          <span class="navbar__tab-text">My Practice</span>
        </RouterLink>
        </template>
      </div>

      <div class="navbar__account">
        <AccountDropdown
          @sign-out="handleSignOut"
        />
      </div>
    </div>
  </div>
</template>
  
<script>
import AccountDropdown from './AccountDropdown.vue'
import SwitchPlatformMenu from './SwitchPlatformMenu.vue'
import { CLINICAL_CALENDAR_ONLY } from '@/utils/viScope'

export default {
  name: 'Navbar',
  components: {
    AccountDropdown,
    SwitchPlatformMenu
  },
  data() {
    return {
      profileImageLoaded: false,
      clinicalCalendarOnly: CLINICAL_CALENDAR_ONLY
    }
  },
  computed: {
    loginUserInfo() {
      return this.$store.state.login.userInfo
    }
  },
  async mounted() {
    // Initialize user data in Vuex store if available, matching personal settings page pattern
    if (this.loginUserInfo) {
      this.$store.commit('myPractice/userInfo/SET_USERINFO', this.loginUserInfo);
      this.$store.commit('myPractice/userInfo/SET_DATALOADED');
      this.$store.dispatch('myPractice/account/getSettingData');
    } else {
      await this.$store.dispatch('myPractice/userInfo/getUserInfo');
    }
  },
  methods: {
    handleBackToDocumentTemplate() {
      this.$router.push('/my-workbench/document-template')
    },
    isActive(path) {
      return this.$route?.path?.includes(path)
    },
    handleSignOut() {
      this.$store.dispatch('login/logout')
    }
  }
}
</script>
  
<style scoped>
.navbar {
  background: #FFFFFF;
  box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.10);
  position: relative;
  z-index: 1000;
}

.navbar__inner {
  height: 60px;
  padding: 10px 24px;
  display: grid;
  grid-template-columns: minmax(200px, 1fr) auto minmax(200px, 1fr);
  align-items: center;
  gap: 12px;
}

.navbar__left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.navbar__logo {
  width: 36px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar__portal {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px;
  cursor: pointer;
  user-select: none;
  color: #374957;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.2px;
}

.navbar__portal:hover {
  border-radius: 5px;
  background-color: rgba(124, 212, 218, 0.05);
  color: #7CD4DA;
}

.navbar__portal:focus {
  outline: none;
}

.navbar__portal-icon {
  width: 21px;
  height: 21px;
  display: inline-flex;
}

.navbar__tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 4px 8px;
  min-width: 0;
  max-width: 800px;
  margin: 0 auto;
}

.navbar__tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 8px;
  color: #374957;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0.2px;
  white-space: nowrap;
  text-decoration: none;
}

.navbar__tab:hover {
  color: #7CD4DA;
}

.navbar__tab--active {
  color: #8BBDC7;
}

.navbar__tab-icon {
  width: 21px;
  height: 21px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.navbar__separator {
  width: 2px;
  height: 24px;
  background: #C4C4C4;
  border-radius: 1px;
  flex-shrink: 0;
}

.navbar__account {
  position: relative;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
}

.navbar__account-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 16px;
  border-radius: 24px;
  border: 1px solid transparent;
  background: #F9FBFD;
  color: #374957;
  cursor: pointer;
}

.navbar__account-trigger:hover {
  border-color: #004879;
}

.navbar__account-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #D1D5DB;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.navbar__account-avatar-initials {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #1E4670;
}

.navbar__account-text {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333333;
}

.navbar__account-caret {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  color: #374957;
}

.navbar__account-caret--open {
  transform: rotate(180deg);
}

.navbar__account-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  width: 320px;
  background: #F9FBFD;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 12px;
  z-index: 50;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.12);
}

.user-profile-section-container {
  box-shadow: 0 1px 15px 0 rgba(74, 74, 74, 0.15);
}

.navbar__account-profile {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 12px;
}

.navbar__account-profile-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.navbar__account-profile-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #D1D5DB;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar__account-profile-initials {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #1E4670;
}

.navbar__account-profile-text {
  text-align: center;
}

.navbar__account-profile-name {
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.navbar__account-profile-email {
  margin: 4px 0 0;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #6B7280;
}

.navbar__account-menu {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 8px 0;
}

.navbar__account-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #374957;
}

.navbar__account-menu-item:hover {
  background: #F3F4F6;
}

.navbar__account-menu-item--danger {
  color: #D10000;
}

.navbar__account-menu-item--danger:hover {
  background: rgba(209, 0, 0, 0.08);
}
</style>